import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-lien-he-popup',
  templateUrl: './lien-he-popup.component.html',
  styleUrls: ['./lien-he-popup.component.css']
})
export class LienHePopupComponent implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<LienHePopupComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
  }
  tenNCC:string=""
  sdt:string=""
  diaChi:string=""
  // email:string =""
  ngOnInit(): void {
    this.tenNCC = this.data.tenNCC
    this.sdt = this.data.sdt
    this.diaChi = this.data.diaChi
    // this.email  = this.data.email
  }

  Close() {
    this.dialogRef.close();
  }
}
